import { css } from '@/styled-system/css';

export const uploadedAttachmentListStyles = css.raw({
  alignItems: 'flex-end',
  display: 'flex',
  flexDirection: 'row',
  gap: 'tight',
  paddingRight: 'loose',
  overflowX: 'auto',
});

export const uploadedWrapperStyles = css.raw({
  position: 'relative',
  marginTop: 'xs',
  paddingBottom: 'default',
});

export const linearGradientStyles = css.raw({
  background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.80) 60%, #FFF 100%)',
  height: '100%',
  width: '25px',
  position: 'absolute',
  top: 0,
  right: 0,
  pointerEvents: 'none',
});
